import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { HttpStatusCode } from 'axios';
import globalProgramStore from '../../../../../stores/program-store';

export const createNewServiceOperation = async (
  branchId: number | undefined,
  programId: number | undefined,
  selectedYear: number,
  serviceIds: number[],
  setLoading: (loading: boolean) => void,
  closeDialog: () => void,
) => {
  try {
    if (!branchId) {
      toast.warn('לא ניתן לאתר את השלוחה המבוקשת נסה שוב בעוד מספר רגעים...');
    }

    if (!programId) {
      toast.warn('לא ניתן לאתר את מזהה הקורס');
    }
    if (serviceIds.length === 0) {
      toast.warn('יש לבחור את השרותים הרלוונטים');
      return;
    }
    setLoading(true);
    const res = await appApi.addServiceToProgram(
      branchId!,
      programId!,
      selectedYear,

      serviceIds,
    );

    if (res.status === HttpStatusCode.Ok) {
      globalProgramStore.updateProgramDetails(programId, res.data.body);

      toast.success('הוספת השרותים בהצעה בהצלחה');
    }

    setLoading(false);
    closeDialog();
  } catch (e) {
    console.error(`createNewServiceOperation is failed with the error: ${e}`);
    setLoading(false);
    toast.error('יצירת השרות נכשלה');
  }
};
